// Checks if PostHog is available in the global scope
const isPostHogAvailable = () => {
	if (typeof posthog === "undefined") {
		console.warn("PostHog is not available.")
		return false
	}

	return true
}

export { isPostHogAvailable }